import { Amplify } from 'aws-amplify';
import { Auth } from 'aws-amplify';
import { AnimatePresence } from 'framer-motion';
import { toast, Toaster, ToastBar } from 'react-hot-toast';

import { COGNITO } from './utils/aws';
import AppRoutes from 'src/Router/routes';

import './App.css';
import { useEffect } from 'react';

Amplify.configure({
  aws_cognito_region: COGNITO.REGION,
  aws_user_pools_id: COGNITO.USER_POOL_ID,
  aws_user_pools_web_client_id: COGNITO.APP_CLIENT_ID,
});

function App(): JSX.Element {
  const redirectToLogin = async () => {
    try {
      await Auth.currentAuthenticatedUser();
    } catch (error) {
      if (window.location.pathname !== '/login') {
        window.location.pathname = '/login';
      }
    }
  };
  // useEffect(() => {
  //   redirectToLogin();
  // }, []);
  return (
    <AnimatePresence>
      <Toaster>
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button onClick={() => toast.dismiss(t.id)}>X</button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
      <AppRoutes key={1} />
    </AnimatePresence>
  );
}

export default App;
